import { useEffect, useState } from 'react';
import './scss/Preloader.scss';
import Logo, { LogoMobile } from '../Sidebar/Logo';
import { useWhiteLabel } from '../../context/WhiteLabelContext';
import { isPotentialWhiteLabelDomain } from '../../utils/whiteLabelUtils';

const Preloader = ({ loading }) => {
  const [hidden, setHidden] = useState(false);
  const [removed, setRemoved] = useState(false);

  const {
    isWhiteLabel,
    branding,
    loading: whiteLabelLoading
  } = useWhiteLabel();

  const isPotentialWhiteLabel = isPotentialWhiteLabelDomain();

  const preloaderConfig = branding?.preloader || {};
  const {
    enabled = true,
    type = 'default',
    customLogo
  } = preloaderConfig;

  useEffect(() => {
    if (!loading) {
      setHidden(true);
      const timer = setTimeout(() => {
        setRemoved(true);
      }, 0);
      return () => clearTimeout(timer);
    }
  }, [loading]);

  if (isWhiteLabel()) return null;

  if (isPotentialWhiteLabel && whiteLabelLoading) return null;

  return (
    <div className={`zoobbe-preloader ${hidden ? 'hidden' : ''}`}>
      <div className="zoobbe-preloader-content">
        <div className="zoobbe-preloader-logo">
          <LogoMobile width={'80px'} />
        </div>
        <div className="zoobbe-preloader-from">
          <span>from</span>
          <span className="zoobbe-text">
            <Logo width={'60px'} />
          </span>
        </div>
      </div>
    </div>
  );
};

export default Preloader;
